<ng-container *transloco="let t">
  @let shippingCostResponse = this.shippingCostResponse();

  @if (hasFreeShippingGrantedAmount(shippingCostResponse)) {
    <!-- Free parcel shipping granted -->
    <div style="max-width: 100%">
      <pxw-alert type="success" size="sm" display="inline-block" style="width: 100%">
        <pxw-icon icon="price-discount" #customIcon />
        {{ t('shippingCostResponse.freeShippingGranted') }}
      </pxw-alert>
    </div>
  } @else if (hasMinimumPurchaseErrorAmount(shippingCostResponse)) {
    <!-- Minimum purchase error for parcel -->
    <pxw-shipping-not-allowed
      [isFormSubmitted]="isFormSubmitted()"
      [message]="
        t('shippingCostResponse.minimumPurchaseError', {
          minimumPurchase: shippingCostResponse.minimumPurchaseErrorAmount | currencyFormat,
        })
      "
    />
  } @else if (hasPostalCodeRequired(shippingCostResponse)) {
    <!-- Postal code required for parcel shipping -->
    <pxw-shipping-not-allowed
      [isFormSubmitted]="isFormSubmitted()"
      [message]="t('shippingCostResponse.postalCodeRequiredForParcel')"
    />
  } @else if (hasDeliveryCostToBeDefined(shippingCostResponse)) {
    <!-- Parcel delivery cost to be defined -->
    <pxw-shipping-continue-with-confirmation
      [(outOfDeliveryZoneConfirmed)]="outOfDeliveryZoneConfirmed"
      [isFormSubmitted]="isFormSubmitted()"
      [message]="'No pudimos calcular el costo de envío en este momento.'"
    />
  } @else if (
    hasAvailableParcelOptions(shippingCostResponse) &&
    shippingCostResponse.availableParcelOptions.length > 1
  ) {
    <!-- Multiple parcel options available - show selector always -->
    <pxw-shipping-options-selector
      [availableOptions]="shippingCostResponse.availableParcelOptions"
      [selectedOption]="selectedParcelOption()"
      [isFormSubmitted]="isFormSubmitted()"
      (selectedOptionChange)="onParcelOptionSelected($event)"
    />

    <!-- Branch selector for pickup at branch options -->
    @if (requiresBranchSelection() && apiUrl() && establishmentId()) {
      <div class="branch-selector-container">
        <pxw-branch-selector
          [apiUrl]="apiUrl()"
          [establishmentId]="establishmentId()"
          [stateId]="stateIdFromPostalCode()"
          [postalCode]="postalCode()"
          [isFormSubmitted]="isFormSubmitted()"
          [selectedBranchId]="selectedBranch()?.code || null"
          [userCoordinates]="userCoordinates()"
          (selectedBranchChange)="onBranchSelected($event)"
        />
      </div>
    }

    @if (hasMinimumPurchaseForFreeShipping(shippingCostResponse)) {
      <!-- Can unlock free parcel shipping -->
      <pxw-alert
        type="info"
        appareance="bare"
        size="xs"
        display="inline-block"
        style="margin-top: 0.3em"
      >
        <pxw-icon icon="price-discount" #customIcon />
        *
        {{
          t('shippingCostResponse.minimumPurchaseForFreeShipping', {
            minimumPurchaseForFreeShipping:
              shippingCostResponse.minimumPurchaseForFreeShipping | currencyFormat,
          })
        }}
      </pxw-alert>
    }
  } @else if (hasShippingEstimateError(shippingCostResponse)) {
    <!-- Parcel shipping estimate error -->
    @let dimInfo = dimensionsExceededInfo();
    @if (dimInfo?.dimensionsExceeded && dimInfo?.calculatedDimensions; as dims) {
      <!-- Dimensions exceeded error with details -->
      <pxw-shipping-continue-with-confirmation
        [(outOfDeliveryZoneConfirmed)]="outOfDeliveryZoneConfirmed"
        [isFormSubmitted]="isFormSubmitted()"
        [message]="
          t('parcelShippingError.dimensionsExceededDetails', {
            length: dimInfo!.calculatedDimensions!.length,
            width: dimInfo!.calculatedDimensions!.width,
            height: dimInfo!.calculatedDimensions!.height,
            weight: dimInfo!.calculatedDimensions!.weightKg || 0,
          })
        "
      />
      <p class="parcel-error-contact">{{ t('parcelShippingError.contactStore') }}</p>
    } @else {
      <!-- Generic error -->
      <pxw-shipping-continue-with-confirmation
        [(outOfDeliveryZoneConfirmed)]="outOfDeliveryZoneConfirmed"
        [isFormSubmitted]="isFormSubmitted()"
        [message]="t('parcelShippingError.genericError')"
      />
    }
  }
</ng-container>
